import Vue from "vue";
import VueRouter from "vue-router";
import { ROUTER_PATH } from "@/constants/common.js";

Vue.use(VueRouter);

const routes = [
  {
    path: ROUTER_PATH.LOGIN,
    name: "login",
    component: () => import("../views/account/Login.vue"),
    meta: { title: "登录", needLogin: false }
  },
  {
    path: ROUTER_PATH.ACCOUNT_FORGET_PASSWORD,
    name: "forgetPassword",
    component: () => import("../views/account/ForgetPassword.vue"),
    meta: { title: "忘记密码", needLogin: false }
  },
  {
    path: "/",
    name: "layout",
    component: () => import("../views/layout"),
    redirect:ROUTER_PATH.PROCESS_LIST,
    children: [
      {
        path: ROUTER_PATH.ACCOUNT_INFO,
        name: "accountInfo",
        component: () => import("../views/account/AccountInfo.vue"),
        meta: { title: "账户信息", needLogin: true }
      },
      {
        path: ROUTER_PATH.ACCOUNT_RESET_PASSWORD,
        name: "accountResetPassword",
        component: () => import("../views/account/ResetPassword.vue"),
        meta: { title: "重置密码", needLogin: true }
      },
      {
        path: ROUTER_PATH.LOGIN_OUT,
        name: "accountLoginOut",
        component: () => import("../views/account/LoginOut.vue"),
        meta: { title: "登出", needLogin: true }
      },
      {
        path: ROUTER_PATH.ACCOUNT_FORGET_PASSWORD,
        name: "accountForgetPassword",
        component: () => import("../views/account/ForgetPassword.vue"),
        meta: { title: "忘记密码", needLogin: false }
      },
      {
        path: ROUTER_PATH.PROCESS_LIST,
        name: "process",
        component: () => import("../views/process/Process.vue"),
        meta: { title: "流程", needLogin: true }
      },
      {
        path: ROUTER_PATH.ROBOT_RUNNING_REPORT,
        name: "robotRunningReport",
        component: () => import("../views/robot/RunningReport.vue"),
        meta: { title: "报表", needLogin: true }
      },
      {
        path: ROUTER_PATH.ROBOT_MONITOR,
        name: "robotMonitor",
        component: () => import("../views/robot/Monitor.vue"),
        meta: { title: "监控" }
      },     
      {
        path: ROUTER_PATH.ROBOT_MY_ROBOT,
        name: "robotMyRobot",
        component: () => import("../views/robot/MyRobot.vue"),
        meta: { title: "机器人", needLogin: true }
      },
      {
        path: ROUTER_PATH.PAY_REPORT,
        name: "payReport",
        component: () => import("../views/pay/PayReport.vue"),
        meta: { title: "账单", needLogin: true }
      },
      {
        path: ROUTER_PATH.ADMIN_USER,
        name: "listUser",
        component: () => import("../views/admin/ListUser.vue"),
        meta: { title: "用户管理", needLogin: true }
      },
      {
        path: ROUTER_PATH.ADD_USER,
        name: "addUser",
        component: () => import("../views/admin/AddUser.vue"),
        meta: { title: "创建用户", needLogin: true }
      },
      {
        path: ROUTER_PATH.UPDATE_USER,
        name: "updateUser",
        component: () => import("../views/admin/UpdateUser.vue"),
        meta: { title: "修改用户", needLogin: true }
      },
      {
        path: ROUTER_PATH.ADMIN_ROLE,
        name: "listRole",
        component: () => import("../views/admin/ListRole.vue"),
        meta: { title: "角色管理", needLogin: true }
      },
      {
        path: ROUTER_PATH.ADD_ROLE,
        name: "addRole",
        component: () => import("../views/admin/AddRole.vue"),
        meta: { title: "创建角色", needLogin: true }
      }
    ]
  },
  {
    path: "/error",
    name: "errorPage",
    component: () => import("../views/layout"),
    children: [
      {
        path: "/404",
        name: "Page404",
        component: () => import("../views/errorPage/404.vue"),
        meta: { title: "Page 404" }
      },
      {
        path: "/401",
        name: "Page401",
        component: () => import("../views/errorPage/401.vue"),
        meta: { title: "Page 401" }
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  routes
});

export default router;
